import { useEffect } from 'react';

import useTranslation from '../../customHooks/translate';
import { Link } from 'react-router-dom';

import { fadeInUp } from './landing-motion';

const icons: Record<string, JSX.Element> = {
  key: (
    <img
      key="key-icon"
      src="assets/hero-key.svg"
      alt="key"
      className="inline-block h-[0.85em] w-[0.85em] object-contain align-middle"
    />
  ),
  check: (
    <img
      key="check-icon"
      src="assets/hero-check.svg"
      alt="check"
      className="inline-block h-[0.85em] w-[0.85em] object-contain align-middle"
    />
  ),
};

function parseWithIcons(text: string): (string | JSX.Element)[] {
  const parts = text.split(/(\{key\}|\{check\})/);
  return parts.map((part) => {
    const match = part.match(/^\{(\w+)\}$/);
    if (match) return icons[match[1]] ?? part;
    return part;
  });
}

const Hero = () => {
  const translation = useTranslation();

  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem('user') || '{}');
    if (userInfo) {
      window.location.href = '/dashboard';
    }
  }, []);

  return (
    <section
      id="product"
      className="m-auto mt-[48px] flex max-w-[900px] flex-col gap-[20px] px-[16px] md:mt-[100px] md:px-0"
    >
      <img
        src="assets/hero-bg.svg"
        alt="hero"
        aria-hidden="true"
        className="pointer-events-none absolute bottom-0 left-0 z-[-1] w-full object-cover"
        style={{
          maskImage: 'linear-gradient(to top, transparent 0%, black 30%)',
          WebkitMaskImage: 'linear-gradient(to top, transparent 0%, black 10%)',
        }}
      />
      <div
        className={`text-center text-[clamp(2rem,5vw,3.5rem)] font-bold leading-tight text-[#2d3036] ${fadeInUp}`}
        style={{ animationDelay: '0.06s' }}
      >
        {parseWithIcons(translation.home.ProductParagraph.ProductParagraphText)}
      </div>
      <p
        className={`text-center text-[16px] font-normal leading-[2] text-[rgba(41,45,50,1)] opacity-70 ${fadeInUp}`}
        style={{ animationDelay: '0.14s' }}
      >
        {translation.home.ProductParagraphContent.ProductParagraphContentText}
      </p>
      <div
        className={`flex w-full flex-col items-center justify-center gap-[20px] md:mt-[16px] md:flex-row md:gap-[40px] ${fadeInUp}`}
        style={{ animationDelay: '0.22s' }}
      >
        <Link to="/register">
          <button className="rounded-[8px] bg-[rgba(70,106,251,1)] px-[20px] py-[12px] text-[16px] font-medium text-white transition-all duration-300 hover:-translate-y-[2px] hover:bg-[rgba(70,106,251,0.95)] hover:shadow-[0_10px_24px_rgba(70,106,251,0.24)] active:translate-y-0">
            {
              translation.home.ProductParagraphContent
                .ProductParagraphContentButton
            }
          </button>
        </Link>
        <Link to="/instructions">
          <button
            type="button"
            className="group flex items-center gap-[6px] rounded-[8px] bg-transparent px-[20px] py-[12px] text-[16px] font-medium text-[rgba(70,106,251,1)] transition-all duration-300 hover:-translate-y-[1px] hover:bg-[rgba(70,106,251,0.08)] hover:shadow-[0_8px_16px_rgba(70,106,251,0.12)] active:translate-y-0"
          >
            {translation.home.ProductParagraphContent.ProductParagraphContentLink}
            <img
              className="h-[16px] w-[16px] transition-transform duration-300 group-hover:translate-x-[2px]"
              src="assets/play.svg"
              alt=""
            />
          </button>
        </Link>
      </div>
    </section>
  );
};

export default Hero;
